export enum AndsendModel {
    GPT_O4_MINI = 'o4-mini',
    GPT_4_1_MINI = 'gpt-4.1-mini',
    GPT_4_1 = 'gpt-4.1',
    GEMINI_2_0_FLASH_LITE = 'gemini-2.0-flash-lite',
    GEMINI_2_0_FLASH = 'gemini-2.0-flash-001',
    GEMINI_2_5_FLASH_PREVIEW = 'gemini-2.5-flash-preview',
}
